<app-modal-header [modalTitle]="modalTitle" showCloseBtn (closeModal)="dynamicDialogRef.close()"></app-modal-header>
<!-- Modal Content -->
<div class="modal-content h-100 w-100" [attr.loading]="loading" [attr.size]="'large'" [attr.flexDirection]="'row'">
    <section *ngIf="!loading" class="primary-section-container h-100 w-100">
        <mat-stepper #stepper class="reco-buy-qty-modal-stepper">
            <mat-step>
                <ng-template matStepLabel>Upload File</ng-template>
                <div class="reco-buy-stepper-main-content">
                    <app-upload-grids
                        class="upload-grids-container"
                        [colDefJSONSettings]="uploadNewRecoBuyQty"
                        [generateGridColumnsFunc]="'RecoBuyQtyUpload_GenerateGridData'"
                        gridTitle="Reco Buy Qty Upload Data"
                        [displayHeader]="true"
                        [exportFileName]="'New Reco Buy Qty'"
                        [autoSelectOptions]="[]"
                        [uploadIsEnabled]="true"
                        [processingData]="processingData"
                        [autoSizeColumns]="true"
                        [checkDuplicatesAPIFunc]="checkExistingAPIFunc"
                        [prodFields]="prodFields"
                        [positiveNumberFields]="positiveNumberFields"
                        [nonNegativeNumberFields]="nonNegativeNumberFields"
                        [requiredORPairs]="requiredORPairs"
                        [requiredPairs]="requiredPairs"
                        [requiredPairsDirectional]="requiredPairsDirectional"
                        [templateDownloadMessage]="templateDownloadMessage"
                    >
                    </app-upload-grids>
                </div>
                <div class="bottom-buttons">
                    <button
                        mat-raised-button
                        matStepperNext
                        color="primary"
                        class="submit-btn submit-btn-dark-reverse"
                        type="button"
                        [disabled]="
                            !gridDetails['Reco Buy Qty Upload Data'] ||
                            gridDetails['Reco Buy Qty Upload Data']?.rowData.length === 0 ||
                            gridDetails['Reco Buy Qty Upload Data']?.rowDataIncomplete
                        "
                    >
                        Next
                    </button>
                    <button
                        mat-button
                        (click)="dynamicDialogRef.close()"
                        type="button"
                        color="warn"
                        class="text-warning mdc-button mat-mdc-button mat-warn mat-mdc-button-base"
                        matStepperCancel
                    >
                        Close
                    </button>
                </div>
            </mat-step>
            <mat-step>
                <ng-template matStepLabel>Plan Details</ng-template>
                <div class="reco-buy-stepper-main-content">
                    <mat-form [formGroup]="detailsFormGroup">
                        <div>
                            <mat-form-field>
                                <mat-label>Assortment Plan Name (unique)</mat-label>
                                <input matInput type="text" formControlName="planNameControl" />
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Buying Season</mat-label>
                                <mat-select formControlName="buyingSeasonControl">
                                    <mat-option *ngFor="let option of buyingSeasonOptions" [value]="option">
                                        {{ option }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div>
                            <mat-form-field>
                                <mat-label>Max Plan Retail Cost $</mat-label>
                                <input
                                    matInput
                                    type="number"
                                    formControlName="maxPlanRetailCostControl"
                                    placeholder="e.g. 50000"
                                />
                            </mat-form-field>
                        </div>
                        <div>
                            <mat-label>Run Reco Buy Quantification After Save</mat-label>
                            <mat-checkbox formControlName="runAfterSaveControl" />
                        </div>
                    </mat-form>
                </div>
                <div class="bottom-buttons justify">
                    <button
                        mat-raised-button
                        color="lte"
                        class="submit-btn submit-btn-dark-reverse"
                        type="button"
                        class=""
                        matStepperPrevious
                    >
                        Back
                    </button>
                    <button
                        mat-raised-button
                        color="primary"
                        class="submit-btn-dark-reverse"
                        type="button"
                        (click)="onSaveToRepository()"
                        [disabled]="
                            !detailsFormGroup.get('planNameControl').value ||
                            !detailsFormGroup.get('buyingSeasonControl').value ||
                            !detailsFormGroup.get('maxPlanRetailCostControl').value
                        "
                    >
                        Save to Repository
                    </button>
                </div>
            </mat-step>
        </mat-stepper>
    </section>
    <!-- Loading Component -->
    <app-loader *ngIf="loading" [loadingMessage]="loadingMessage"></app-loader>
</div>
